import { Component, OnInit, OnDestroy, Inject,EventEmitter,Output } from '@angular/core';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { Subscription } from 'rxjs';
import { environment } from './../../environments/environment';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-playerinfobox2',
  templateUrl: './playerinfobox2.component.html',
  styleUrls: ['./playerinfobox2.component.scss']
})
export class Playerinfobox2Component implements OnInit, OnDestroy {
  isDraft = false;
  isRanking = false;
  isMobile = false;
  league: any = null;
  lgm_id: Number = 0;
  players: any = null;
  player_id: Number = 0;
  draftedPosition = 0;
  positions = [];
  summary: any = {};
  playerData: any = {};
  gameLogs: any = {};
  news: any = {};
  picker_id: any = 0;
  pick_number = 0;
  selectedTab = 0;
  @Output() onAdd = new EventEmitter<any>();
  s_draftActiveSub: Subscription;
  s_isMobileScreen: Subscription;
  s_pickPlayer: Subscription;
  player: any = null;
  playerIndex = -1;
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  teamColors: any = {};
  imgversion='1.1115';
  cache: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) private data, private store: Store<any>, private _resultboardService: ResultboardService, private dialog: MatDialog) {
    this.s_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    this.isDraft = (this.data.isDraft != null) ? this.data.isDraft : false;
    this.isRanking = (this.data.isRanking != null) ? this.data.isRanking : false;
    this.league = (this.data.league != null) ? this.data.league : 0;
    this.lgm_id = (this.data.lgm_id != null) ? this.data.lgm_id : 0;
    this.players = (this.data.players != null) ? this.data.players : [];
    if (!this.isDraft && this.players.length && this.players[0].order != null) {
      // sort players by order
      this.players.sort((a, b) => {
        if (a.order == null || b.order == null) return 0;
        return a.order > b.order ? 1 : -1;
      });
    }
    this.player_id = (this.data.player_id != null) ? this.data.player_id : 0;
    this.playerData = (this.data.player_data != null) ? this.data.player_data : {};
    this.cache = (this.data.cache != null) ? this.data.cache : true;
    this.teamColors = {0 : '#000000', 1 : '#FFFFFF'};
  }

  ngOnInit() {
    if (this.league.active_season_id == null) {
      this.getActiveSeason(() => {
        this.getPlayer();
      });
    } else {
      this.getPlayer();
    }
    if (this.isDraft) this.setupSocket();
  }

  getPlayer() {
    if (this.players.length) {
      this.players.forEach((p, i) => {
        if (p.id == this.player_id) {
          this.playerIndex = i; // need this for next and previous
          this.player = p;
        }
      });
    }
    this.getSummary();
  }

  getActiveSeason(callback) {
    this._resultboardService.getActiveSeason(this.league.game_id).subscribe(res => {
      this.league.active_season_id = res.id;
      callback();
    });
  }

  setupSocket() {
    if (this.s_pickPlayer) this.s_pickPlayer.unsubscribe();
    this.s_pickPlayer = this._resultboardService.pickChanges().subscribe(res => {
      // console.log('pick_changes', res);
      if (res.entities.league.id == this.league.id) {
        this.pick_number = res.entities.pick_info_box.pick_number;
        this.picker_id = (res.entities.pick_info_box.is_active == 1) ? this.lgm_id : -1;
      }
    });
    if (this.s_draftActiveSub) this.s_draftActiveSub.unsubscribe();
    this.s_draftActiveSub = this._resultboardService.draftActiveOn().subscribe(res => {
      // console.log('draft_active', res);
      this.positions = res.entities.availPosition;
      if (res.entities.player_uuid != null && res.entities.player_uuid == 4599 && this.positions.length > 1 && this.positions.indexOf("P") == 0) {
        this.positions.push(this.positions.shift());
      }
      this.draftedPosition = this.positions[0];
      this.picker_id = res.entities.picker_id;
      this.pick_number = res.entities.pick_number;
    });
    // send draft active emit to get response
    this._resultboardService.sendDraftActive(this.league.id, this.player_id, this.player.pn);
  }

  ngOnDestroy() {
    if (this.s_draftActiveSub) this.s_draftActiveSub.unsubscribe();
    if (this.s_isMobileScreen) this.s_isMobileScreen.unsubscribe();
    if (this.s_pickPlayer) this.s_pickPlayer.unsubscribe();
  }

  getColumns(obj) {
    const res = [];
    Object.keys(obj).forEach(key => {
      if (key.indexOf('col') > -1) res.push(key);
    });
    return res;
  }

  getSummary() {
    let simple = this.league.simple=='Y'?'Y':'N';
    const sub = this._resultboardService.getInfobox(this.player_id, this.league.active_season_id, this.league.id, this.league.abbr, 'summary',simple, this.cache).subscribe(res => {
      if (res.status == 'success') {
        this.summary = res.entities;
        this.summary.summaryCols = (this.summary.summaryTable.length) ? this.getColumns(this.summary.summaryTable[0]) : [];
        this.summary.summaryAvgCols = this.getColumns(this.summary.summaryAvgTable);
        this.summary.summaryTfootCols = this.getColumns(this.summary.summaryTfootTable);
        if (this.summary.playerDetail != null) {
          this.playerData['fn'] = this.summary.playerDetail.first_name;
          this.playerData['ln'] = this.summary.playerDetail.last_name;
          this.playerData['pp'] = this.summary.playerDetail.profile_pic;
          this.playerData['tn'] = this.summary.playerDetail.team_abbr;
          this.playerData['tid'] = this.summary.playerDetail.team_id;
          this.teamColors = (this.summary.playerDetail.tcolo) ? this.summary.playerDetail.tcolo.split(',') : {0 : '#000000', 1 : '#FFFFFF'};
        }
        sub.unsubscribe();
      }
    });
  }

  getGameLogs() {
    const sub = this._resultboardService.getInfobox(this.player_id, this.league.active_season_id, this.league.id, this.league.abbr, 'game_log').subscribe(res => {
      if (res.status == 'success') {
        this.gameLogs = res.entities;
        this.gameLogs.summaryCols = (this.gameLogs.summaryTable.length) ? this.getColumns(this.gameLogs.summaryTable[0]) : [];
        // console.log(this.gameLogs);
        sub.unsubscribe();
      }
    });
  }

  getNews() {
    const sub = this._resultboardService.getInfobox(this.player_id, this.league.active_season_id, this.league.id, this.league.abbr, 'news').subscribe(res => {
      if (res.status == 'success') {
        this.news = res.entities;
        // console.log(this.news);
        sub.unsubscribe();
      }
    });
  }

  changeTab(event) {
    if (event.index == 1 && !this.gameLogs.length) {
      this.getGameLogs();
    } else if (event.index == 2 && !this.news.length) {
      this.getNews();
    }
  }

  getColWidth(arr) {
    var width = (76 / (arr.length - 4));
    return (width > 2.50) ? width : 2.50;
  }

  getItemSummary(item) {
    if (item.panelState) {
      // open
      if (this.isMobile) {
        if (item.summary.length > 150) {
          return item.summary.substr(0, 150) + '...';
        } else {
          return item.summary;
        }
      } else {
        if (item.summary.length > 300) {
          return item.summary.substr(0, 300) + '...';
        } else {
          return item.summary;
        }
      }
    } else {
      // close
      if (this.isMobile) {
        if (item.summary.length > 75) {
          return item.summary.substr(0, 75) + '...';
        } else {
          return item.summary;
        }
      } else {
        if (item.summary.length > 100) {
          return item.summary.substr(0, 100) + '...';
        } else {
          return item.summary;
        }
      }
    }
  }

  draftPlayer() {
    if (this.picker_id == this.lgm_id) {
      const data = {
        picker_id: String(this.lgm_id),
        league_id: String(this.league.id),
        player_id: String(this.player_id),
        player_name: this.playerData.fn + ' ' + this.playerData.ln,
        player_team: this.playerData.tn,
        player_position: this.draftedPosition,
        pick_number: Number(this.pick_number),
        plr_team_id: String(this.playerData.tid),
        profile_pic: this.playerData.pp,
        device: 'web',
        pickedFrom: 'infobox',
      };
      const sub = this._resultboardService.draftButtonEmit(data).subscribe(res => {
        sub.unsubscribe();
      });
    }
    this.dialog.closeAll();
  }

  addToMyRanking() {
      let data = {
        player: this.player,
        playerIndex: this.playerIndex
      }
      this.onAdd.emit(data);
      this.playerIndex--;
      this.players = this.players.filter(player=>{
        return (player.id != this.player.id);
      });
      this.nextPlayer();
  }

  nextPlayer() {
    this.playerIndex++;
    this.player_id = this.players[this.playerIndex].id;
    this.playerData = (this.players[this.playerIndex] != null) ? this.players[this.playerIndex] : {};
    this.getPlayer();
    this.selectedTab = 0;
    this._resultboardService.sendDraftActive(this.league.id, this.player_id, this.player.pn);
  }

  prevPlayer() {
    this.playerIndex--;
    this.player_id = this.players[this.playerIndex].id;
    this.playerData = (this.players[this.playerIndex] != null) ? this.players[this.playerIndex] : {};
    this.getPlayer();
    this.selectedTab = 0;
    this._resultboardService.sendDraftActive(this.league.id, this.player_id, this.player.pn);
  }
  
  textFontClass(value, index) {
    let textClass = {};
    if (value && value[0] && value[1]) {
      if (value[0] == 'W' && value[1] == '(') {
        textClass['greenfontColor'] = true;
      }
      else if(value[0] == 'L' && value[1] == '(') {
        textClass['redfontColor'] = true;
      }
    }
    if (this.league.game_id == 5 && index == 0) {
      textClass['leftAligned'] = true;
    }
    return textClass;
  }
  
  appendColumn(index) {
    if (this.league && this.league.game_id == 5) {
      return index == 0 || index > 1;
    }
    else {
      return index == 0 || index > 2;
    }
  }
  
  addColspan(index) {
    if (this.league && this.league.game_id == 5) {
      return index == 0 ? 2 : 1;
    }
    else {
      return index == 0 ? 3 : 1;
    }
  }
}
